export default __webpack_public_path__ + "static/media/copy.3dc821c4.svg";